<template>
	<div class="container-md mh-100">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection text="Balance del vendedor" :breadcrumb="true" />
			</template>
			<template #actions>
				<div class="hstack gap-2 justify-content-md-end">
					<button type="button" class="btn btn-sm btn-dark rounded-pill flex-shrink-0" :disabled="!balance || balance.amount == 0" @click="pay">Registrar pago</button>
				</div>
			</template>
		</LayoutHeaderSection>
		<main class="pt-5 pb-10 pb-0 vstack gap-5">
			<UserCardMedium :user="balance.user" :balance="balance" v-if="balance?.user" />
			<LayoutTableMain title="Historial de movimientos" :results="results" :loading="loading" @goPage="goPage">
				<template #body>
					<CompanyAdminBalanceDetailTableRow v-for="data in results?.data" v-bind:key="data.id" :transaction="data" :currency="balance?.currency" />
				</template>
			</LayoutTableMain>
		</main>

		<CompanyAdminBalancePayment ref="modalPayment" @reload="getData" />
	</div>
</template>

<script>
	import { ref, reactive, onMounted } from 'vue';
	import router from '@/router';
	import store from '@/store';
	import composableForm from '@/composables/form';
	import CompanyAdminBalanceRepository from '@/repositories/modules/Company/Admin/Balance';

	export default {
		props: {
			id: String
		},
		setup(props) {
			const { loading, catchError } = composableForm();
			const balance = ref(null);
			const results = ref({});
			const filters = reactive({
				orderBy: 'created_at',
				orderMethod: 'desc',
				take: 20,
				page: 1
			});

			const getBalance = async () => {
				await CompanyAdminBalanceRepository.show(props.id).then((response) => {
					balance.value = response.data;
				}).catch((e) => {
					catchError(e, true);
					router.push({ name: 'company.admin.home' });
				});
			}

			const getResults = async () => {
				loading.value = true;

				await CompanyAdminBalanceRepository.transactions(props.id, filters).then((response) => {
					results.value = response.data;
				}).catch((e) => {
					catchError(e, true);
					router.push({ name: 'company.admin.home' });
				});

				loading.value = false;
			}

			const getData = () => {
				getBalance();
				getResults();
			}

			const goPage = (page) => {
				filters.page = page;
				getResults();
			}

			const modalPayment = ref(null);
			const pay = () => modalPayment.value.show(balance.value);

			onMounted(getData);

			return { loading, filters, balance, results, goPage, getData, modalPayment, pay };
		}
	}
</script>